import { useState } from 'react';

const PEN_COLORS = [
  '#000000', '#FF0000', '#0066FF', '#00CC00',
  '#FFD700', '#FF6600', '#9900FF', '#FF69B4'
];
const HL_COLORS = [
  '#FFFF00', '#00FF00', '#00BFFF', '#FF69B4', '#FFA500', '#DA70D6'
];

const FloatingToolbar = ({
  activeTool, setActiveTool,
  toolSettings, setToolSettings,
  onUndo, onRedo, canUndo, canRedo,
  onClearAll, onSave, saving,
  eraserMode, setEraserMode
}) => {
  const [showColors, setShowColors] = useState(false);
  const [showEraserMenu, setShowEraserMenu] = useState(true);

  const colors = activeTool === 'highlighter' ? HL_COLORS : PEN_COLORS;
  const isEraser = activeTool === 'eraser';
  const isHand = activeTool === 'hand';
  const isDrawingTool = !isHand;

  return (
    <div className="floating-toolbar">
      {/* ============ ردیف ابزارها (اسکرول‌پذیر در موبایل) ============ */}
      <div className="toolbar-row">

        {/* ابزارها */}
        <div className="toolbar-tools">
          {[
            { id: 'hand', icon: '✋', label: 'دست (جابجایی)' },
            { id: 'pen', icon: '✏️', label: 'مداد' },
            { id: 'highlighter', icon: '🖍️', label: 'ماژیک' },
            { id: 'eraser', icon: '🧹', label: 'پاک‌کن' },
          ].map(t => (
            <button
              key={t.id}
              className={`tool-btn ${activeTool === t.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTool(t.id);
                if (t.id !== 'eraser') {
                  setShowEraserMenu(false);
                } else {
                  setShowEraserMenu(true);
                }
              }}
              title={t.label}
              aria-label={t.label}
            >
              {t.icon}
            </button>
          ))}
        </div>

        {/* دکمه رنگ — فقط برای مداد و ماژیک */}
        {isDrawingTool && !isEraser && (
          <div className="toolbar-colors">
            <button
              className="color-trigger"
              style={{ background: toolSettings.color }}
              onClick={() => setShowColors(v => !v)}
              aria-label="انتخاب رنگ"
            />
          </div>
        )}

        {/* اسلایدر اندازه — برای رسم */}
        {isDrawingTool && (
          <div className="toolbar-size">
            <input
              type="range"
              min={isEraser ? 10 : 1}
              max={isEraser ? 50 : activeTool === 'highlighter' ? 40 : 20}
              value={toolSettings.size}
              onChange={e => setToolSettings(s => ({ ...s, size: +e.target.value }))}
              className="size-slider"
              aria-label="اندازه"
            />
          </div>
        )}

        {/* Undo / Redo */}
        <div className="toolbar-actions">
          <button onClick={onUndo} disabled={!canUndo} title="واگرد">↶</button>
          <button onClick={onRedo} disabled={!canRedo} title="ازنو">↷</button>
        </div>

        {/* Clear / Save */}
        <div className="toolbar-actions">
          <button onClick={onClearAll} className="clear-btn" title="پاک کردن همه">🗑️</button>
          <button onClick={onSave} disabled={saving} className="save-btn" title="ذخیره">
            {saving ? '⏳' : '💾'}
          </button>
        </div>

      </div>

      {/* ============ منوها — بیرون از toolbar-row، بدون کلیپ شدن ============ */}

      {/* منوی پاک‌کن: ضربه‌ای یا ناحیه‌ای */}
      {isEraser && showEraserMenu && (
        <div className="eraser-menu">
          <button
            className={eraserMode === 'stroke' ? 'active' : ''}
            onClick={() => setEraserMode('stroke')}
          >🗑️ حذف خط</button>
          <button
            className={eraserMode === 'area' ? 'active' : ''}
            onClick={() => setEraserMode('area')}
          >🎯 حذف ناحیه</button>
        </div>
      )}

      {/* انتخاب رنگ */}
      {showColors && isDrawingTool && !isEraser && (
        <div className="color-picker">
          {colors.map(c => (
            <button
              key={c}
              className={`color-swatch ${toolSettings.color === c ? 'active' : ''}`}
              style={{ background: c }}
              onClick={() => {
                setToolSettings(s => ({ ...s, color: c }));
                setShowColors(false);
              }}
              aria-label={`رنگ ${c}`}
            />
          ))}
          <input
            type="color"
            value={toolSettings.color}
            onChange={e => setToolSettings(s => ({ ...s, color: e.target.value }))}
            className="custom-color-input"
            title="رنگ دلخواه"
          />
        </div>
      )}
    </div>
  );
};

export default FloatingToolbar;